export default {
  message: {
    changeLanguage: '切换成英文',
    homepage: {
      module_1_title: 'LOONG: LLM-powered autOnomous Optical Network aGent',
      module_1_text: `LOONG是一个基于智能光网络现网实验平台的研究项目，致力于实现并展示 L4 和 L5 级别的全生命周期自动驾驶光网络。该项目旨在通过现网示范研究，搭建学术界与工业界之间的桥梁，促进基于AI智能体的光网络智能管控技术的落地应用。`,
      news: {
      }
    },
    demopage: {
      testbed_title: '现网研究平台',
      demo_title: '演示',
      testbed_text: 'LOONG智能光网络研究平台位于中国长三角地区，覆盖从上海经嘉兴至杭州的440公里环形光纤链路，由四段G.652.D光纤和六个光放大器组成。该平台基于大模型AI智能体、SDN控制器和秒级数据采集能力，推动光网络“自动驾驶”愿景的实现。',
      tasks: {
        'item1': {
          title: '演示一: 故障处理',
          description: `在光纤老化处理中，Agent中集成的时间序列预测模块在预测到5 dB的光功率衰减时会触发处理流程。随后，Planner 使用 LLM（大型语言模型）自主生成一系列工作流程。根据该工作流程，Agent 会检索相关文档手册，并查询系统的实时光功率值来计算每段光纤的衰减值。然后Agent会将计算得到的光纤衰减值与手册中的标准衰减值进行比较。在比较和分析后，Agent 能够成功定位出衰减值异常的光纤。成功定位后，Agent 可以重新配置链路中的光放大器，以缓解传输质量的下降。实验结果表明，LLM 拥有强大的推理能力，能够高效处理来自多个来源和多种格式的与故障相关的信息。`
        },
        'item2': {
          title: '演示二：LLM自主功率优化',
          description: `该演示探索了利用大语言模型（LLM）在LLM原生（LLM-native）模式下进行光功率优化的可能性。系统通过M.C.模块将LLM作为直接优化器，通过Planner生成配置建议，并通过M.A.模块将其部署到实验测试平台。系统将六个放大器的增益作为待优化参数，通过六个接收机的平均Q-值作为优化效果评估指标。基于ReAct框架，LLM通过观察-思考-行动（observe-think-act）循环进行优化。视频记录显示了LLM如何制定计划（将优化分为探索和精细化阶段），执行动作（"set_all_EDFAgain"），观察结果（Q_average），并在后续步骤中展示推理过程。结果表明，LLM的优化成功提高了平均Q-值。`
        }
      }
    },
    newspage: {
      news: {
        'item1': {
          title: 'LOONG网页正式上线！',
          time: '[01/2025]'
        },
        'item2': {
          title: '基于LOONG项目的两篇论文被OFC会议接收！',
          time: '[12/2024]'
        },
        'item3': {
          title: '我们展示了首个基于大型语言模型 AI Agent 的全生命周期光网络自动调控现网示范，充分体现了当前人工智能技术在光网络管控中的潜力和创新应用！',
          time: '[09/2024]'
        },
        'item4': {
          title: '诸葛群碧老师受邀在OFC 2025做Tutorial报告：“Digital Twin and AI Agent for Autonomous Optical Networks”！',
          time: '[09/2024]'
        }
      }
    },
    publicationpage: {
      publications_1: {
        'item1': {
          description: {
            'item1': {
              content: '我们设计了首个用于自动驾驶光网络（ADON）的基于大型语言模型（LLM）的AI Agent，并在现网实验中进行了实现。我们提出了Agent在全生命周期的网络管理中的三种运行模式。基于这三种运行模式，Agent能够高效完成光网络中的上波/下波任务，处理光网络中的软/硬故障，并在功率优化方面实现了与专家设计算法相当的性能。',
              link: ''
            }
          }
        },
        'item2': {
          description: {
            'item1': {
              content: '我们提出了一种用于自动驾驶光网络（ADON）的可信光功率优化策略。现网实验表明，该策略可以在保持 4 dB的Q-值性能裕度的同时，实现可靠的光功率优化。即使在初始Q-值性能裕度仅为 0.15 dB的极端情况下，策略仍能将系统光功率优化到最优附近，并在优化过程中保持系统性能在阈值以上。'
            }
          }
        },
        'item3': {
          description: {
            'item1': {
              content: '我们提出了一种基于启发式算法的配置顺序优化方案，用于实现自动驾驶光网络（ADON）中光放大器的可靠配置。方案在商用设备搭建的测试平台上进行了验证，该方案成功避免了最大1.0 dB的Q-值性能下降，并且优于98.5%的随机生成的光放大器配置顺序。'
            }
          }
        }
      },
      publications_2: {
        'item1': {
          description: {
            'item1': {
              content: '在本教程中，我们介绍和讨论了构建光网络数字孪生的三个关键技术，包括建模、遥测和自学习。我们介绍了这些技术在影响传输质量的主要损伤方面的原理和进展，并对剩余的挑战和未来研究方向进行了讨论。',
              link: ''
            }
          }
        },
        'item2': {
          description: {
            'item1': {
              content: '在本工作中，我们提出了一个贝叶斯推理框架（BIF）来构建光放大器的数字孪生并以数据高效的方式控制光功率演化。仅采集信息量大的数据来平衡数据空间的探索和利用，从而实现高效的自动驾驶光网络（ADON）。仿真和实验表明，BIF可以将建模掺铒光纤放大器所需的数据量减少80%，建模拉曼放大器所需的数据量减少60%。'
            }
          }
        },
        'item3': {
          description: {
            'item1': {
              content: '本文提出了一种可以同时优化和建模的新框架，称为“SMOF”。该框架可以同时对拉曼放大器进行建模和增益谱优化。通过迭代地冻结和解冻数字孪生的内部参数，可以调整泵浦配置实现理想的增益谱。 ',
              link: ''
            }
          }
        },
        'item4': {
          description: {
            'item1': {
              content: '本文提出了一种旨在找到不确定参数到其对应真实值映射的输入参数优化（IR）范式。提出的IR范式的主要优势在于其适用于动态光网络，在系统参数（如上波条件和光器件配置）经常发生变化的情况下，提出的IR范式不需要重复进行。文中详细讨论了如何使用所提出的范式来提升拉曼放大器（RA）模型精度。结果表明，所提出的IR方案可以将基于物理的RA模型的平均预测误差从约0.92 dB降低到约0.20 dB，并将最大绝对误差从约3.09 dB降低到约1.12 dB。'
            }
          }
        }
      }
    },
    timeline: {
      event1: {
        date: '六月',
        title: '项目启动',
        description: ''
      },
      event2: {
        date: '九月',
        title: '实验室研究平台搭建',
        description: '实验室智能光网络研究平台搭建完成'
      },
      event3: {
        date: '六月',
        title: '现网研究平台搭建',
        description: '上海-嘉兴-杭州智能光网络研究平台搭建完成'
      },
      event4: {
        date: '九月',
        title: 'AI Agent管控现网示范',
        description: '实现首个基于大型语言模型 AI Agent 的全生命周期光网络自动调控现网示范'
      }
    },
    nav_list: {
      Home: {
        text: '首页'
      },
      Demo: {
        text: '演示'
      },
      Publications: {
        text: '论文'
      },
      News: {
        text: '新闻'
      },
      Team: {
        text: '团队'
      }
    },
    grouppage: {
      group_title: '团队介绍'
    }
  }
}
